import React from 'react';
import {
  MotifFormField,
  MotifSelect,
  MotifLabel,
  MotifOption,
} from '@ey-xd/motif-react';

export default (props) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
      }}
    >
      <MotifFormField>
        <MotifLabel data-testid="lblServiceName">Service Name</MotifLabel>
        <MotifSelect
          name={`serviceName.${props.data.uniqueKey}`}
          id={`serviceName.${props.data.uniqueKey}`}
          data-testid="divServiceName"
          placeholder="Select a service..."
          className="motif-select-hide-clear"
          filter
          lblPosition="out"
          value={props.data.propertyAmenityName}
          onChange={(value) =>
            props.handleServiceNameChange(
              value,
              props.data.uniqueKey,
              props.colDef.field
            )
          }
        >
          {props.options.map((co) => (
            <MotifOption data-testvalue={co.text} key={co.key} value={co.value}>
              {co.text}
            </MotifOption>
          ))}
        </MotifSelect>
      </MotifFormField>
    </div>
  );
};
